<template>
	<div>
		<el-tooltip placement="top" :open-delay="500" :content="disabledReason" :disabled="hasSelectedRows">
			<div> <!-- Wrapping is needed because otherwise tooltip does not work on disabled button -->
				<md-button style="min-width: 40%; height: 35px;"
						   :class="{'md-primary': hasSelectedRows}"
						   :disabled="!hasSelectedRows"
						   @click="apply">{{ $t("investor.exchange.table.operation.bid.button") }}
				</md-button>
			</div>
		</el-tooltip>
	</div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
	computed: {
		...mapGetters(["exchangeCheckedRows"]),
		hasSelectedRows() {
			return this.exchangeCheckedRows.length > 0;
		},
		disabledReason() {
			return this.$t("investor.exchange.table.operation.bid.selectionRequired");
		},
	},
	methods: {
		apply() {
			if (!this.hasSelectedRows) {
				return;
			}
			this.params.bidOnAllSelected();
		},
	}
};
</script>

<style lang="scss" scoped>
@import "src/components/templates/investor/exchange/bidInput.scss";
</style>
